import Helper from '@ember/component/helper';
import { MessageDisplay } from 'cio/app-models/in-app/in-app-message';
import { inAppMessageDisplayLabel } from 'cio/utils/in-app/message-config';

export default class extends Helper {
  compute([display]: [MessageDisplay]) {
    if (display == null) {
      return '';
    }
    return inAppMessageDisplayLabel(display);
  }
}
